function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "14",
  height: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 0c3.86 0 7 3.14 7 7s-3.14 7-7 7-7-3.14-7-7 3.14-7 7-7zm0 1.077A5.93 5.93 0 001.077 7 5.93 5.93 0 007 12.923 5.93 5.93 0 0012.923 7 5.93 5.93 0 007 1.077zm2.692 7.897a.54.54 0 010 1.077H4.308a.54.54 0 010-1.077zm0-2.512a.54.54 0 010 1.076H4.308a.54.54 0 010-1.076zm0-2.513a.54.54 0 010 1.077H4.308a.54.54 0 010-1.077z",
  fill: "#54585D",
  fillRule: "nonzero"
})));